import { LuFileVideo, LuX } from "react-icons/lu";

/** Small square thumbnail for a pending (pre-send) attachment in the composer. */
export default function AttachmentChip({ kind, name, previewUrl, onRemove }) {
    return (
        <div
            className="group relative h-16 w-16 shrink-0 overflow-hidden rounded-[var(--radius-sm)] border border-[var(--border-primary)] bg-[var(--bg-secondary)]"
            title={name}
        >
            {kind === "image" ? (
                <img src={previewUrl} alt={name} className="h-full w-full object-cover" />
            ) : (
                <div className="flex h-full w-full flex-col items-center justify-center gap-1 px-1.5">
                    <LuFileVideo className="h-5 w-5 text-[var(--text-secondary)]" />
                    <span className="w-full truncate text-center text-[9px] leading-tight text-[var(--text-tertiary)]">
                        {name}
                    </span>
                </div>
            )}
            {onRemove && (
                <button
                    type="button"
                    onClick={onRemove}
                    aria-label={`Remove ${name}`}
                    className="absolute right-1 top-1 flex h-5 w-5 items-center justify-center rounded-full bg-black/60 text-white hover:bg-black/80 sm:opacity-0 sm:group-hover:opacity-100"
                >
                    <LuX className="h-3 w-3" />
                </button>
            )}
        </div>
    );
}
